module.exports = __webpack_public_path__ + "img/book.a60db731.png";